export default "__VITE_ASSET__BjfNMNT5__"